function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun-data-science-3680756");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-data-science-3680756",
  transform: "translate(0.610000, 0.628000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M230.39,135.622 C277.011,135.622 316.402,115.942 316.402,92.661 L316.402,71.294 C299.453,88.103 267.672,99.224 230.39,99.224 C193.105,99.224 161.316,88.103 144.378,71.294 L144.378,92.661 C144.378,115.942 183.761,135.622 230.39,135.622 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.39,86.102 C277.011,86.102 316.402,66.387 316.402,43.051 C316.402,19.715 277.011,-1.42108547e-14 230.39,-1.42108547e-14 C183.761,-1.42108547e-14 144.378,19.715 144.378,43.051 C144.378,66.387 183.761,86.102 230.39,86.102 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M379.49,459.462 C379.49,481.126 397.744,498.751 420.178,498.751 C442.569,498.751 460.78,481.118 460.78,459.462 C460.78,437.806 442.573,420.173 420.178,420.173 C397.74,420.176906 379.49,437.798 379.49,459.462 L379.49,459.462 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.39,185.232 C277.011,185.232 316.402,165.517 316.402,142.181 L316.402,120.849 C299.464,137.63 267.675,148.744 230.39,148.744 C193.105,148.744 161.316,137.631 144.378,120.849 L144.378,142.181 C144.378,165.517 183.761,185.232 230.39,185.232 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.4,191.802 L316.4,170.435 C299.451,187.244 267.67,198.365 230.388,198.365 C193.103,198.365 161.314,187.244 144.376,170.435 L144.376,191.802 C144.376,215.138 183.759,234.853 230.388,234.853 C277.009,234.853 316.4,215.138 316.4,191.802 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.7,459.462 C189.7,481.126 207.954,498.751 230.388,498.751 C252.822,498.751 271.076,481.118 271.076,459.462 C271.076,437.806 252.822,420.173 230.388,420.173 C207.954,420.176906 189.7,437.798 189.7,459.462 L189.7,459.462 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-1.42108547e-14,459.462 C-1.42108547e-14,481.126 18.219,498.751 40.602,498.751 C63.036,498.751 81.29,481.118 81.29,459.462 C81.29,437.806 63.036,420.173 40.602,420.173 C18.207,420.176906 -1.42108547e-14,437.798 -1.42108547e-14,459.462 L-1.42108547e-14,459.462 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.6,407.052 C42.8227,407.052 45.0023,407.22778 47.1625,407.48169 L47.1625,329.96169 L223.8225,329.96169 L223.8225,407.46969 C225.9748,407.21578 228.1623,407.04 230.385,407.04 C232.6077,407.04 234.7952,407.21578 236.9475,407.46969 L236.9475,329.96169 L413.6075,329.96169 L413.6075,407.46969 C415.7598,407.21578 417.9395,407.04 420.17,407.04 C422.4005,407.04 424.5802,407.21578 426.7325,407.4775 L426.7325,323.3995 C426.7325,319.7784 423.7911,316.837 420.17,316.837 L236.94,316.837 L236.94,247.79 C234.7603,247.868126 232.5923,247.97359 230.3775,247.97359 C228.1627,247.97359 225.9947,247.86812 223.815,247.79 L223.815,316.837 L40.585,316.837 C36.9639,316.837 34.0225,319.7784 34.0225,323.3995 L34.0225,407.4775 C36.1866,407.21578 38.3623,407.05172 40.585,407.05172 L40.6,407.052 Z",
  id: "Path"
})));

var SvgDataScience = function SvgDataScience(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "462px",
    height: "500px",
    viewBox: "0 0 462 500",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataScience, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DataScience.ae1a8cc1.svg";
export { ForwardRef as ReactComponent };